function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-2 0H4v-4h4v4zm-4-6h4v-4H4v4zm10 0h-4v-4h4v4zm2-10v4h4V4h-4zm-2 4h-4V4h4v4zm2 6h4v-4h-4v4zm4 6h-4v-4h4v4z",
  fill: "#666"
})));